//@flow
import React, { Component } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import getter from 'dibs-object-getter';
import mobileCheck from 'dibs-client-check/src/mobileCheck';

import styles from './LoyaltyModulesWrapper.scss';

import TpnFaq from './TpnFaq';
import InviteColleagues from './InviteColleagues';
import EnrollCta from './EnrollCta';
import { WhatMembersLove } from './components/WhatMembersLove';
import { BenefitsChart } from './components/BenefitsChart/BenefitsChart';
import { BenefitsChartMobile } from './components/BenefitsChartMobile/BenefitsChartMobile';
import { DetailedBenefits } from './components/DetailedBenefits';

import type { LoyaltyModulesWrapper_viewer as Viewer } from './__generated__/LoyaltyModulesWrapper_viewer.graphql';
import type { LoyaltyModulesWrapper_user as User } from './__generated__/LoyaltyModulesWrapper_user.graphql';

type LoyaltyModulesWrapperProps = {|
    onCallCompleted?: () => void,
    enrollmentPage?: boolean,
    registerDeepLink?: (Element, string) => void,
    viewer: Viewer,
    user: User,
|};

// export this so other components can link to the chart
export const BENEFITS_CHART_ID = 'benefits-chart-2019';

class LoyaltyModulesWrapper extends Component<LoyaltyModulesWrapperProps> {
    componentDidMount() {
        if (this.props.onCallCompleted) {
            this.props.onCallCompleted();
        }
    }
    render() {
        const { props } = this;

        const viewer = getter(props).value('viewer') || {};
        const tradeFirm =
            getter(props)
                .at('user')
                .value('tradeFirm') || {};

        return (
            <div className={styles.bottomContainer} data-tn="loyalty-modules-wrapper">
                <div className={styles.bottomSection}>
                    <div className={styles.benefits2019Section}>
                        <WhatMembersLove />
                    </div>
                    <div className={styles.benefitsChartSection} id={BENEFITS_CHART_ID}>
                        {mobileCheck.any() ? (
                            <BenefitsChartMobile
                                tradeFirm={(tradeFirm: Object)}
                                viewer={(viewer: Object)}
                            />
                        ) : (
                            <BenefitsChart
                                tradeFirm={(tradeFirm: Object)}
                                viewer={(viewer: Object)}
                            />
                        )}
                    </div>
                    <div
                        className={`${styles.benefits2019Section} ${
                            styles.detailedBenefitsPadding
                        }`}
                    >
                        <DetailedBenefits registerDeepLink={this.props.registerDeepLink} />
                    </div>
                    <EnrollCta
                        enrollmentPage={props.enrollmentPage}
                        tradeFirm={(tradeFirm: Object)}
                    />
                    <InviteColleagues tradeFirm={(tradeFirm: Object)} />
                </div>
                <TpnFaq />
            </div>
        );
    }
}

export { LoyaltyModulesWrapper };

export default createFragmentContainer(LoyaltyModulesWrapper, {
    viewer: graphql`
        fragment LoyaltyModulesWrapper_viewer on Viewer {
            ...BenefitsChart_viewer
            ...BenefitsChartMobile_viewer
        }
    `,
    user: graphql`
        fragment LoyaltyModulesWrapper_user on User {
            tradeFirm {
                ...InviteColleagues_tradeFirm
                ...EnrollCta_tradeFirm
                ...BenefitsChart_tradeFirm
                ...BenefitsChartMobile_tradeFirm
            }
        }
    `,
});
